// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__oeqR6","label":"styles_label__SHmbq","caption":"styles_caption__jB1tH","description":"styles_description__NkoRc","content":"styles_content__G7_V7"};